import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from "react-router-dom";
import { httpRequest } from '../../../helpers/httpService';


import appConfig from '../../../config/env';
import helpers from '../../../helpers/helpers';
import appSession from '../../../helpers/session';
import Swal from 'sweetalert2';
import DropDownSelection from '../../elements/DropDownSelection';
import InputText from '../../elements/InputText';
import InputTextArea from '../../elements/InputTextArea';
import Radio from '../../elements/Radio';
import InputNumber from '../../elements/InputNumber';
import RenderErrors from '../../elements/RenderErrors';
import Loader from '../../parts/Loader';
import LoginForm from '../../parts/LoginForm';
import store from '../../../helpers/store';
 
function RegistrationEvent ({target_step = 1}){
    const api_url = appConfig.apiUrl;
    const { event_id } = useParams();
    const is_authenticated = helpers.isAuthenticated();
    const [event_data, setEvent] = useState({});
    const [field_data, setFields] = useState({});
    const [option_data, setOptions] = useState({});

    const [profile_data, setProfile] = useState({});

    const [registration_data, setRegistration] = useState({});
    const [registration_other_data, setOtherRegistration] = useState({});

    const [payment_data, setPayment] = useState({
        registration_amount: 0,
        donation_amount: 0,
        payment_method: 1,
        payment_frequency: 1,
        payment_type: 1,
        restriction_code: ''
    });

    const [step, setStep] = useState(1);
    const [errors, setErrors] = useState([]);
    const [loading, setLoading] = useState(1);
    const [data_loaded, setDataLoaded] = useState(1);

    const [total_amount, setTotalAmount] = useState(0);

    const [input_fields, setInputFields] = useState();

    let navigate = useNavigate();

    useEffect(() => {
        //Mounted
        getEventData()
    }, []);

    useEffect(() => {
        //Mounted

        let data = {};
        for (var key in registration_data) {
           data[key] = profile_data[key];
        }
        //setRegistration({...field_name})
        //setRegistration(data)

    }, [field_data]);

    useEffect(() => {
        generateInputFields()
    }, [
        registration_data, 
        registration_other_data, 
        profile_data, 
        errors
    ]);

    useEffect(() => {
        calculateAmount()
    }, [payment_data.registration_amount, payment_data.donation_amount]);

    function calculateAmount(){
        let registration = payment_data.registration_amount
        let donation = payment_data.donation_amount;

        let amount = parseInt(registration) + parseInt(donation);

        setTotalAmount(amount)
    }

    function inputRegistration(e) {
        let { value, name } = e.target;

        if (e.target.type === "checkbox") {
            if (e.target.checked) {
                value = 1;
            } else {
                value = 0;
            }
        }

        let new_state = { [name]: value }
        setRegistration({ ...registration_data, ...new_state });

        
        //let other_input = {...registration_other_data}
        //delete other_input[name];

        var custom_field = field_data.find(item => item.field_name === name)
        const {other_input, other_input_keyword} = custom_field;

        let other_data = {...registration_other_data}
        if(other_input){
            if(other_input_keyword == value){
                other_data[name] = "";
            }
            else{
                delete other_data[name];
            }
        }else{
            delete other_data[name];
        }

        setOtherRegistration(other_data);
    }

    function inputOtherRegistration(e) {
        let { value, name } = e.target;

        if (e.target.type === "checkbox") {
            if (e.target.checked) {
                value = 1;
            } else {
                value = 0;
            }
        }

        let new_state = { [name]: value }

        setOtherRegistration({ ...registration_other_data, ...new_state });
    }

    function displayOtherInput(field_name, field_label = ''){
        var custom_field = field_data.find(item => item.field_name === field_name)
        const {other_input, other_input_keyword} = custom_field;

        if(other_input){
            if(registration_data[field_name] == other_input_keyword){

                return <InputText
                            id={field_name} 
                            name={field_name} 
                            value={registration_other_data[field_name]}
                            labelClass='d-block mt-2'    
                            tagClass="form-control mb-0"
                            onChange={inputOtherRegistration}
                            onFocus={removeErrors}
                            placeholder={`Please Specify ${field_label}...`}
                        />
                    }
        }

        return false;
    }

    function inputPayment(e) {
        let { value, name } = e.target;

        if (e.target.type === "checkbox") {
            if (e.target.checked) {
                value = 1;
            } else {
                value = 0;
            }
        }

        if(name == 'donation_amount' && !value){
            value = 0;
        }

        let new_state = { [name]: value }

        setPayment({ ...payment_data, ...new_state });
    }

    function removeErrors(e){
        let { name } = e.target;
        let newErrors = {...errors}

        delete newErrors[name];

        setErrors(newErrors);
    }

    function getEventData() {
        const url = api_url + '/public/events/'+event_id;

        httpRequest(url, "GET")
            .then((res) => {
                setEvent(res);
                restructureOptionData(res.options)
                getSession()
                setDataLoaded(1)

                // Set Registration Amount
                if(res.registration_type == 'paid' && res.registration_price){
                    let new_state = { 'registration_amount': res.registration_price }
                    setPayment({ ...payment_data, ...new_state });
                }
            })
            .catch((err) => {
                setDataLoaded(0)
                setLoading(0)
            });
    }

    function getSession(){
        //const url = `${appConfig.apiUrl}/public/session`;
        let url = api_url + '/public/session';
        let token = false;

        if(is_authenticated){
            url = api_url + '/client/session';
            token = true;
        }


        httpRequest(url, "POST", {
            postdata: {
                ...appSession.getSessionTokenObj(),
                apps_token: appConfig.appToken,
                ref_id: event_id,
            },
            headers: {
                "Content-Type": "application/json",
            },
        }, token)
            .then((res) => {
                if(!res.session_key){
                    Swal.fire({
                        title: "Error!",
                        text: 'Invalid session',
                        icon: "error",
                        //html: error_list,
                        confirmButtonText: "OK",
                    });
                }

                if(res.session_key != appSession.getSessionKey()){
                    appSession.setSessionToken(res.session_key) //update or create new sessiom
                    //alert('new session')
                }

                
                getEventFields(res.donor);

                if(res.donor){
                    //console.log(res.donor)
                    //console.log({ ...registration_data, ...res.donor })
                    //setRegistration({ ...registration_data, ...res.donor });
                }
            })
            .catch((err) => {
                setLoading(0)
                let errors = err.data;
                let error_list = '';

                if(err.data){
                    Object.keys(err.data).map((key) => {
                        error_list += "<li>" + errors[key][0] + "</li>"
                    });
                    
                    error_list = "<ul>" + error_list + "</ul>"
                }

                Swal.fire({
                    title: "Error!",
                    text: err.message,
                    icon: "error",
                    html: error_list,
                    confirmButtonText: "OK",
                });
            });
    }

    function getEventFields(profile_data = {}) {
        const url = api_url + '/public/events/'+event_id;

        httpRequest(url + '/fields', "GET")
            .then((res) => {
                let field_name = {};
                res.map(function(object, i){
                    field_name[object.field_name] = '';
                })

                field_name = {...field_name, ...profile_data} // Add already fille session data

                setFields(res)
                setRegistration({...field_name, ...profile_data})

                if(is_authenticated){
                    getProfileData(field_name)
                }else{
                    setLoading(0)
                }
                
                if(target_step > 1){
                    setStep(2)
                }
            })
            .catch((err) => {
                console.log(err.message)
                setLoading(0)
            });

    }

    function getProfileData(pre_registration_data) {
        const url = api_url + '/client/profile';

        httpRequest(url, "GET", '', true)
            .then((res) => {
                let data = {...pre_registration_data};
                for (var key in pre_registration_data) {
                    if(res[key]){
                        data[key] = res[key];
                    }
                }

                setRegistration({...data})
                setProfile(res);
                setLoading(0)
            })
            .catch((err) => {
                setRegistration({...pre_registration_data})
                setLoading(0)
            });
    }

    function restructureOptionData(data){
        let options = {};

        Object.entries(data).map(([key, value]) => {
            if(key === 'payment_method'){
                let ids = value.map(function (val) {
                    return val.id;
                });

                options[key] = ids;         
            }
            //Single value
            else{ 
                options[key] = value;
            }
        })
        setOptions({...options})

        // data.map(function(object, i){
        //     if(object.option_name == 'payment_method'){ //Array value
        //         if ('payment_method' in options){ 
        //             let values = options[object.option_name];
        //             values.push(object.option_value) 

        //             options[object.option_name] = values; //Add new option value
        //         }else{
        //             options[object.option_name] = [object.option_value]; //Add value as an array
        //         }
        //     }
        //     else{ //Single value
        //         options[object.option_name] = object.option_value;
        //     }
        // })

        // setOptions({...options})
    }

    function displayPaymentMethod(){
        let method_selection = ''

        if(option_data.hasOwnProperty('payment_method')){
            method_selection = Object.entries(option_data.payment_method).map(([key, value]) => {
                const result = store.payment_methods.find(obj => obj.id === value)

                return <Radio
                            id={`payment-method-${result.id}`}
                            name="payment_method"
                            value={result.id}
                            label={result.name}
                            labelClass={(payment_data.payment_method == value) ? 'item btn-payment checked' : 'item btn-payment'}
                            onChange={inputPayment}
                            onFocus={removeErrors}
                            checked = {payment_data.payment_method == value}
                        />
            });
        }

        return method_selection;
    }

    function getFormData(group = ''){
        let form_data = '';

        if(group == 'registrant'){ //Retrieve registrant data only
            form_data = { ...registration_data, ...registration_other_data }
        }else{
            form_data = { ...registration_data, ...payment_data, ...registration_other_data }
        }

        //form_data.ref_id = event_id
        form_data.session_key = appSession.getSessionTokenObj()
        form_data.apps_token = appConfig.appToken;

        return form_data;
    }
    

    function validateForm(e){
        let new_errors = {...errors}

        /**
         * Dynamically check fields
         */
        if(Object.keys(field_data).length){
            Object.entries(field_data).map(([index, data]) => {
                let {field_name, is_required, other_input, other_input_keyword} = data;
                if(is_required){
                    if(!registration_data[field_name]){
                        new_errors[field_name] = [`The ${field_name.replace(/_/g, " ")} field is required`]
                    }
                    else if(other_input && !registration_other_data[field_name] && registration_data[field_name] == other_input_keyword){
                        new_errors[field_name] = [`The ${field_name.replace(/_/g, " ")} field must be specified`]
                    }
                    else{
                        delete new_errors[field_name];
                    }
                }
            });
        }

        setErrors(new_errors);

        return new_errors;
    }

    function saveRegistrant(){
        const validate = validateForm();

        console.log(validate)
        console.log(Object.keys(validate).length)

        if(Object.keys(validate).length){
            let message = 'Please check your entry.'

            if(validate.hasOwnProperty('amount')){
                message = validate['amount'];
            }

            setLoading(0)
            Swal.fire({
                text: message,
                icon: "error",
                confirmButtonText: "OK",
            });

            return;
        }

        let url = api_url + '/public/registration/event/'+event_id+'/leads';
        let token = false;

        if(is_authenticated){
            url = api_url + '/client/registration/event/'+event_id+'/leads';
            token = true;
        }

        let form_data = getFormData('registrant') //registrant data only
        setLoading(1);

        httpRequest(url, "POST", {
            postdata: { 
                ...form_data, 
                ...appSession.getSessionTokenObj() 
            },
            headers: {
                "Content-Type": "application/json",
            },
        }, token)
            .then((res) => {
                setLoading(0);

                if(res.hasOwnProperty('donor')){
                    if(Object.keys(res.donor).length > 0){
                        setStep(2)
                        return;
                    }
                }

                Swal.fire({
                    title: 'Error!',
                    text: `Unable to save record. Please try again.`,
                    icon: 'error',
                    confirmButtonText: 'Refresh'
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.location.reload(false)
                    }
                })
            })
            .catch((err) => {
                setLoading(0);
    
                if(err.data){
                    setErrors( err.data );
                    err.message = "Please check your entry";

                    if(err.data.session_key){
                        err.message = "The session key is required or expired.";
                        
    
                        Swal.fire({
                            //title: 'Error!',
                            text: err.message,
                            icon: 'error',
                            confirmButtonText: 'Refresh Page',
                            allowOutsideClick: false
                        }).then((result) => {
                            if (result.isConfirmed) {
                                window.location.reload(false)
                            }
                          })

                        return;
                    }

                    if(err.data.captcha){
                        err.message = err.data.captcha[0];
                    }
                }
    
                Swal.fire({
                    //title: 'Error!',
                    text: err.message,
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
            });

    }

    function checkout(){
        let url = api_url + '/public/registration/event/'+event_id+'/checkout';
        let token = false;

        if(is_authenticated){
            url = api_url + '/client/registration/event/'+event_id+'/checkout';
            token = true;
        }

        let form_data = getFormData() // all data only
        setLoading(1);

        httpRequest(url, "POST", {
            postdata: { 
                ...form_data, 
                ...appSession.getSessionTokenObj() 
            },
            headers: {
                "Content-Type": "application/json",
            },
        }, token)
        .then((res) => {
            setLoading(0);

            if(res.action == 'home'){
                const params = '?status=success&ref='+res.reference_no+'&e='+event_data.id+'&d='+registration_data.first_name
                return navigate("/thankyou/" + params);
            } 
            else if(res.action == 'payment-gateway' && payment_data.payment_method != 3){
                let text = ''
                if(payment_data.payment_method == 1 || payment_data.payment_method == 4){
                    text = 'Pesopay is a secure payment portal which will allow you to safely register your Credit/Debit Card or Gcash details.'
                }else if(payment_data.payment_method == 2){

                    text = 'Paypal is a secure payment portal which will allow you to safely register your payment details'
                }
            
                Swal.fire({
                    title: 'Redirecting to Payment gateway please wait...',
                    text: text,
                    icon: 'info',
                    allowOutsideClick: false,
                    showCancelButton: false, // There won't be any cancel button
                    showConfirmButton: false // There won't be any confirm button
                    
                });

                const body = document.getElementsByTagName("body")[0];
                const div = document.createElement("div");
                div.setAttribute("class", "hidden");
                div.innerHTML = res.form;
                body.appendChild(div);

                setTimeout(() => {
                    document.getElementById("payment-gateway").submit();
                }, 2000);
            }
            else{ // Over-the-counter
                const params = '?status=pending&ref='+res.reference_no+'&e='+event_data.id+'&d='+registration_data.first_name
                return navigate("/thankyou/" + params);
            }
        })
        .catch((err) => {
            setLoading(0);

            if(err.data){
                setErrors( err.data );
                err.message = "Please check your entry";

                // if(err.data.captcha){
                //     err.message = err.data.captcha[0];
                // }
            }

            Swal.fire({
                title: 'Error!',
                text: err.message,
                icon: 'error',
                confirmButtonText: 'OK'
            });
        });
    }

    function generateInputFields(){
        //Render Dynamic Fields
        let input_fields = [];
        if (Object.keys(field_data).length > 0) {
            input_fields = Object.entries(field_data).map(([key, value]) => {
                const {field_name, field_label, field_type, option_list, is_required, other_input, other_input_keyword} = value;
                let output = ''

                if(field_type == 'text'){
                    output =    <div className="col-md-6 mb-3" key={key}>
                                    <InputText
                                        id={field_name} 
                                        name={field_name} 
                                        value={registration_data[field_name]}    
                                        label={is_required ?  field_label + '*' : field_label } 
                                        tagClass="form-control mb-0"
                                        onChange={inputRegistration}
                                        onFocus={removeErrors}
                                        readOnly={profile_data[field_name]}
                                    />
                                    
                                    <RenderErrors 
                                        errors={errors} 
                                        name={field_name} 
                                        className="text-danger fs-7"
                                    />
                                </div>
                }
                else if(field_type == 'textarea'){
                    output =    <div className="col-md-6 mb-3" key={key}>
                                    <InputTextArea
                                        id={field_name} 
                                        name={field_name} 
                                        value={registration_data[field_name]}    
                                        label={is_required ?  field_label + '*' : field_label } 
                                        tagClass="form-control mb-0"
                                        onChange={inputRegistration}
                                        onFocus={removeErrors}
                                        readOnly={profile_data[field_name]}
                                    />
                                    
                                    <RenderErrors 
                                        errors={errors} 
                                        name={field_name} 
                                        className="text-danger fs-7"
                                    />
                                </div>
                }
                if(field_type == 'number'){
                    output =    <div className="col-md-6 mb-3" key={key}>
                                    <InputNumber
                                        id={field_name} 
                                        name={field_name} 
                                        value={registration_data[field_name]}    
                                        label={is_required ?  field_label + '*' : field_label } 
                                        tagClass="form-control mb-0"
                                        onChange={inputRegistration}
                                        onFocus={removeErrors}
                                        readOnly={profile_data[field_name]}
                                    />
                                    
                                    <RenderErrors 
                                        errors={errors} 
                                        name={field_name} 
                                        className="text-danger fs-7"
                                    />
                                </div>
                }
                else if(field_type == 'email'){
                    output =    <div className="col-md-6 mb-3" key={key}>
                                    <InputText
                                        id={field_name} 
                                        name={field_name} 
                                        value={registration_data[field_name]}  
                                        label={is_required ?  field_label + '*' : field_label } 
                                        tagClass="form-control mb-0"
                                        type="email"
                                        onChange={inputRegistration}
                                        onFocus={removeErrors}
                                        readOnly={profile_data[field_name]}
                                    />
                                    
                                    <RenderErrors 
                                        errors={errors} 
                                        name={field_name} 
                                        className="text-danger fs-7"
                                    />
                                </div>
                }
                else if(field_type == 'mobile'){
                    output =    <div className="col-md-6 mb-3" key={key}>
                                    <InputNumber
                                        id={field_name} 
                                        name={field_name} 
                                        value={registration_data[field_name]}  
                                        label={is_required ?  field_label + '*' : field_label } 
                                        tagClass="form-control mb-0"
                                        onChange={inputRegistration}
                                        onFocus={removeErrors}
                                        readOnly={profile_data[field_name]}
                                    />
                                    
                                    <RenderErrors 
                                        errors={errors} 
                                        name={field_name} 
                                        className="text-danger fs-7"
                                    />
                                </div>
                }
                else if(field_type == 'option'){

                    const options = JSON.parse(option_list);
                    let optionProps = {}

                    if(field_name == 'country'){
                        optionProps =  {value:'name', label:'name'};
                    }else{
                        optionProps =  {value:'id', label:'name'};
                    }

                    output =    <div className="col-md-6 mb-3" key={key}>
                                    <DropDownSelection
                                        tagClass="form-select mb-0"
                                        label={ is_required ?  field_label + '*' : field_label } 
                                        name={field_name} 
                                        id={field_name} 
                                        placeholder={ 'Select ' + field_label } 
                                        value={registration_data[field_name]}  
                                        onChange={inputRegistration}
                                        onFocus={removeErrors}
                                        optionList={options}
                                        optionProps ={optionProps}
                                        disabled={profile_data[field_name]}
                                    />
                                    {displayOtherInput(field_name, field_label)}
                                    
                                    <RenderErrors 
                                        errors={errors} 
                                        name={field_name} 
                                        className="text-danger fs-7"
                                    />
                                </div>
                }
                else if(field_type == 'radio'){

                    const options = JSON.parse(option_list);
                    let optionProps = {}

                    output =    <div className="col-md-6 mb-3" key={key}>
                                    <div className='form-group pb-2'>
                                        <label>{ is_required ?  field_label + '*' : field_label }</label><br/>
                                    {
                                        Object.entries(options).map(([key, value]) => {

                                            return <>
                                                <div key={key} className="form-check form-check-inline">
                                                    <Radio
                                                        id={`input-${key}-${field_name}`} 
                                                        name={field_name} 
                                                        value={ value.id}  
                                                        label={value.name} 
                                                        labelClass="form-check-label"
                                                        tagClass="form-check-input radio-box"
                                                        onChange={inputRegistration}
                                                        onFocus={removeErrors}
                                                        checked = {registration_data[field_name] == value.id}  
                                                    />
                                                </div>
                                            </>
                                        })
                                    }
                                    </div>
                                    {displayOtherInput(field_name, field_label)}
                                    
                                    <RenderErrors 
                                        errors={errors} 
                                        name={field_name} 
                                        className="text-danger fs-7"
                                    />
                                    {/* <DropDownSelection
                                        tagClass="form-select mb-0"
                                        label={ is_required ?  field_label + '*' : field_label } 
                                        name={field_name} 
                                        placeholder={ 'Select ' + field_label } 
                                        value={registration_data[field_name]}  
                                        onChange={inputRegistration}
                                        onFocus={removeErrors}
                                        optionList={options}
                                        optionProps ={optionProps}
                                        disabled={profile_data[field_name]}
                                    />
                                    {displayOtherInput(field_name)} */}
                                </div>
                }
                else if(field_type == 'date'){
                    output =    <div className="col-md-6 mb-3" key={key}>
                                    <InputText
                                        id={field_name} 
                                        name={field_name} 
                                        value={registration_data[field_name]}  
                                        label={is_required ?  field_label + '*' : field_label } 
                                        tagClass="form-control mb-0"
                                        type="date"
                                        onChange={inputRegistration}
                                        readOnly={profile_data[field_name]}
                                    />
                                    
                                    <RenderErrors 
                                        errors={errors} 
                                        name={field_name} 
                                        className="text-danger fs-7"
                                    />
                                </div>
                }

                if(field_name === 'salutation'){
                    output = <>{output}<div className="col-md-6" key={key}></div></>
                }
                
                return output
            });
        }

        setInputFields(input_fields)
    }

    return (
        <>
        { 
            !data_loaded ?
                <section className="faith h-100">
                    <div className="container">
                        <div className="parent" style={{width: '100%', minHeight: '700px'}}>
                            <div className="container d-flex flex-column justify-content-center align-items-center">
                                <h1 className="success-title text-center">Oopps! Event not found.</h1>

                                
                                <p className="success-text mb-5 text-center">We can't seem to find the event you're looking for.</p>
                                <Link to='/' className="btn btn-return py-3">Return to Events</Link>
                            </div>
                        </div>
                    </div>
                </section>
            :
                <section className="faith">
                    
                    <div className="container">
                        <div className="parent">
                            <div className="child" style={{position: 'relative'}}>
                                
                                <Loader isLoading={loading}/>

                                <div>
                                    {event_data.image_thumbnail && <img src={ helpers.getFileURL(event_data.image_banner)} className="faith-banner-img mb-4" style={{width: '100%', }} />}
                                    
        
                                    <h1 className="faith-title mb-3">{event_data.title}</h1>
        
                                    <div className="faith-details mb-4" dangerouslySetInnerHTML={{__html: event_data.details}} />

                                    <hr/>
        
                                    <p className="faith-mini-subtitle">
                                    Event Details
                                    </p>
                                    {
                                        Object.keys(event_data).length == 0 ? 
                                        <>
                                        <p className='border bg-light p-3 w-50'></p>
                                        <p className='border bg-light p-3 w-50'></p>
                                        <p className='border bg-light p-3 w-50'></p>
                                        <hr/>
                                        <p className='border bg-light p-5'></p>
                                        </>
                                        
                                    : 
                                        <>
                                        <p className="faith-mini-subtitle">Date: <span className="details-on-faith">{helpers.displayDateOnly(event_data)}</span></p>
                                        <p className="faith-mini-subtitle">Time: <span className="details-on-faith">{helpers.displayTimeOnly(event_data)}</span></p>
                                        <p className="faith-mini-subtitle">Location: <span className="details-on-faith">{helpers.displayVenue(event_data)}</span></p>
                                
                                        <hr/>
                
                                        {helpers.registrationStatus(event_data) == 'completed' &&
                                            <div className='text-center py-5'>

                                                <div className='alert alert-secondarys mb-5'><h4 className='mb-0'>Completed!</h4></div>

                                                <Link to='/' className="btn btn-return py-3">Return to Events</Link>
                                            </div>
                                        }
                
                                        {helpers.registrationStatus(event_data) == 'close' &&
                                            <div className='text-center py-5'>

                                                <div className='alert alert-lights mb-5'><h4 className='mb-0'>Registration is closed!</h4></div>

                                                <Link to='/' className="btn btn-return py-3">Return to Events</Link>
                                            </div>
                                        }

                                        {helpers.registrationStatus(event_data) == 'open' &&
                                            <div className="containercard mx-0 px-0 login-container user-reg-form">
                                                <nav className="navigation-login">
                                                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                                        { !is_authenticated ?
                                                        <button className={!is_authenticated ? 'nav-link active' : 'nav-link'} id="nav-login-tab" data-bs-toggle="tab" data-bs-target="#nav-login" type="button" role="tab" aria-controls="nav-login" aria-selected="false">Login as Registered User</button>: ''}

                                                        <button className={is_authenticated ? 'nav-link active' : 'nav-link'} id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">{is_authenticated ? 'Event Registration' : 'One-time Regsitration'}</button>
                                                    </div>
                                                </nav>
                                                <div className="tab-content" id="nav-tabContent">
                                                    { !is_authenticated ?
                                                    <div className={!is_authenticated ? 'tab-pane fade show active' : 'tab-pane fade'} id="nav-login" role="tabpanel" aria-labelledby="nav-login-tab">
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <LoginForm redirect_to='current'/>
                                                            </div>
                                                        </div>
                                                    </div>: ''}
                                                    
                                                    <div className={is_authenticated ? 'tab-pane fade show active' : 'tab-pane fade'} id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
                                                        <div className="row">
                                                            <div className="col-md-12" id="reg-one-time">
                    
                                                            <form method="post">
                                                                
                                                                {step === 1 && (
                                                                <div className="step step-1">
                                                                    <div className="container px-2">
                                                                        <h4 className="faith-login-title mt-3 px-2">Participant Info</h4>
                                                                        <div className="row px-3">
                    
                                                                            
                                                                            {
                                                                                //Dynamically generate fields
                                                                                input_fields
                                                                            }



                                                                            <div className="container d-flex justify-content-end">
                                                                                <button type="button" className="cancelbtn btn-continue" onClick={saveRegistrant}>Continue</button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            
                                                                )}

                                                                {step ===2 && (
                                                                <div className="step">
                                                                    <div className="container">
                                                                        <div className="row">
                                                                        <h4 className="faith-login-title mt-3 ms-0" id="register">Tickets</h4>
                                                                        <div className="col-12">
                                                                            {
                                                                                event_data.registration_type == 'paid' ? 
                                                                                <p>Ticket is PHP {helpers.formatNumber(event_data.registration_price)}</p>
                                                                                : <p>Ticket is FREE</p>
                                                                                
                                                                            }
                                                                        </div>
                                                                        <div className="col-6 mb-2">
                                                                            <InputNumber
                                                                                id='donation_amount' 
                                                                                name='donation_amount' 
                                                                                value={payment_data.donation_amount}  
                                                                                label={`Optional Donation (Minimum of PHP ${helpers.formatNumber(event_data.minimum_donation)})`  } 
                                                                                tagClass="form-control mb-0"
                                                                                onChange={inputPayment}
                                                                                placeholder='Optional donation amount'
                                                                            />
                                                                            
                                                                            <RenderErrors 
                                                                                errors={errors} 
                                                                                name="donation_amount" 
                                                                                className="text-danger fs-7"
                                                                            />
                                                                        </div>
                                                                        
                                                                        {event_data.restrictions > 0 && (
                                                                            <div className="col-6 mb-2">
                                                                                <InputText
                                                                                    id="restriction_code" 
                                                                                    name="restriction_code" 
                                                                                    value={payment_data['restriction_code']}    
                                                                                    label='Restriction Code*'
                                                                                    tagClass="form-control mb-0"
                                                                                    onChange={inputPayment}
                                                                                    placeholder='Registration restriction code'
                                                                                />
                                        
                                                                                <RenderErrors 
                                                                                    errors={errors} 
                                                                                    name='restriction_code' 
                                                                                    className="text-danger fs-7"
                                                                                />
                                                                            </div>
                                                                            )}

                                                                        <div className="col-12">
                                                                            <label htmlFor="uname"><b>Payment Method</b></label><br />
                                                                            <div className="payment-method-wrap">
                                                                                {
                                                                                    displayPaymentMethod()
                                                                                }
                                                                                
                                                                                {
                                                                                    // option_data.payment_method.includes('1') &&
                                                                                    // <Radio
                                                                                    //     id="cc"
                                                                                    //     name="payment_method"
                                                                                    //     value="1"
                                                                                    //     label='Credit Card'
                                                                                    //     labelClass={(payment_data.payment_method == 1) ? 'item btn-payment checked' : 'item btn-payment'}
                                                                                    //     onChange={inputPayment}
                                                                                    //     onFocus={removeErrors}
                                                                                    //     checked = {payment_data.payment_method == 1}
                                                                                    // />
                                                                                }

                                                                                {
                                                                                    // option_data.payment_method.includes('2') &&

                                                                                    // <Radio
                                                                                    //     id="paypal"
                                                                                    //     name="payment_method"
                                                                                    //     value="2"
                                                                                    //     label='Paypal'
                                                                                    //     labelClass={(payment_data.payment_method == 2) ? 'item btn-payment checked' : 'item btn-payment'}
                                                                                    //     onChange={inputPayment}
                                                                                    //     onFocus={removeErrors}
                                                                                    //     checked = {payment_data.payment_method == 2}
                                                                                    // />
                                                                                }

                                                                                {
                                                                                    // option_data.payment_method.includes('4') &&

                                                                                    // <Radio
                                                                                    //     id="gcash"
                                                                                    //     name="payment_method"
                                                                                    //     value="4"
                                                                                    //     label='Gcash'
                                                                                    //     labelClass={(payment_data.payment_method == 4) ? 'item btn-payment checked' : 'item btn-payment'}
                                                                                    //     onChange={inputPayment}
                                                                                    //     onFocus={removeErrors}
                                                                                    //     checked = {payment_data.payment_method == 4}
                                                                                    // />
                                                                                }

                                                                                {
                                                                                    // option_data.payment_method.includes('3') &&

                                                                                    // <Radio
                                                                                    //     id="bank_deposit"
                                                                                    //     name="payment_method"
                                                                                    //     value="3"
                                                                                    //     label='Bank Deposit'
                                                                                    //     labelClass={(payment_data.payment_method == 3) ? 'item btn-payment checked' : 'item btn-payment'}
                                                                                    //     onChange={inputPayment}
                                                                                    //     onFocus={removeErrors}
                                                                                    //     checked = {payment_data.payment_method == 3}
                                                                                    // />
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-12 payment-summary">
                                                                            <label htmlFor="uname"><b>Payment Summary</b></label>
                                                                            <div className="row">
                                                                            <div className="col-6 d-flex justify-content-start align-items-center">
                                                                                <p className="small text-faded m-0">Optional Donation</p>
                                                                            </div>
                                                                            <div className="col-6 d-flex justify-content-end"><p className="m-0">PHP {helpers.formatNumber(payment_data.donation_amount)}</p></div>
                                                                            </div>
                                                                            <div className="row">
                                                                            <div className="col-6 d-flex justify-content-start align-items-center">
                                                                                <p className="small text-faded m-0">Tickets</p>
                                                                            </div>
                                                                            <div className="col-6 d-flex justify-content-end"><p className="m-0">{helpers.displayPrice(event_data)}</p></div>
                                                                            </div>
                                                                            <hr />
                                                                            <div className="row total-amount">
                                                                            <div className="col-6 d-flex justify-content-start">
                                                                                <h5>Total Amount</h5>
                                                                            </div>
                                                                            <div className="col-6 d-flex justify-content-end"><p>PHP {helpers.formatNumber(total_amount)}</p></div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="container d-flex justify-content-end">
                                                                    <button type="button" className="cancelbtn me-4" onClick={() => setStep(1)}>Back</button>
                                                                    <button type="button" className="cancelbtn" onClick={checkout}>Register</button>
                                                                </div>
                                                                </div>
                                                                )}
                                                            </form>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        </>
                                    }
                                </div>
        
                                
        
        
                            </div>
                        </div>
                    </div>
                </section>
        }
        </>
    )
}
 
export default RegistrationEvent;